import { useAppSelector } from 'redux/store';

export default function useCurrentPublisher() {
  return useAppSelector((state) => state.publisher);
}
